import { type TextStyle } from '../../../../../__generated__/graphql-client-types';
import { resolveHomepageSectionsImage } from '../../../../../helpers/construct/page-content.helper';
import {
	type ContentComponent,
	type ExclusiveDealsContent,
	type ExclusiveDealsCarouselItemContent
} from '../../../../../types/construct.types';
import { type ExclusiveDealsItem } from '../../../../../types/home.types';
import { HomeCarousel } from '../../../../home-components/home-carousel/home-carousel.component';
import { HomeExclusiveDealsCardOption } from '../../../../home-components/home-exclusive-deals-card-option/home-exclusive-deals-card-option.component';

const FONT_COLOR_MAP: Record<string, TextStyle> = {
	black: 'BLACK',
	white: 'WHITE',
	primary: 'PRIMARY',
	secondary: 'SECONDARY',
	dark_grey: 'DARK_GREY',
	'grey-dark': 'DARK_GREY'
};

const resolveTextStyle = (value?: string): TextStyle => {
	return FONT_COLOR_MAP[value?.toLowerCase() ?? 'black'] ?? 'BLACK';
};

export const transformCarouselItem = (item: ExclusiveDealsCarouselItemContent): ExclusiveDealsItem => {
	const { artwork, fontColor, image, link, subtitle, title } = item.fields;

	return {
		__typename: 'HomePageExclusiveDealsItem',
		title: title ?? '',
		subtitle: subtitle ?? null,
		textStyle: resolveTextStyle(fontColor),
		artworkImage: resolveHomepageSectionsImage(artwork),
		image: resolveHomepageSectionsImage(image),
		trackingLink: {
			__typename: 'TrackingLink',
			name: title ?? '',
			url: link.linkUrl ?? '',
			tracking: link.trackingCode ?? ''
		}
	};
};

// TODO: EFDC-36937 - HomeCarousel is tightly coupled to GraphQL fragment types. Once the migration is complete,
// refactor HomeCarousel to consume construct types directly and remove the fragment dependencies.

export const ExclusiveDealsHandler: ContentComponent<ExclusiveDealsContent> = ({ content }) => {
	const items = content.fields.carousel.items.map(transformCarouselItem);

	return <HomeCarousel CardComponent={HomeExclusiveDealsCardOption} items={items} />;
};
